var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTagEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3756_17527",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3756_17527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.975 11.0253H3.83542L8.73542 6.12526L7.875 5.26484L2.975 10.1648V11.0253ZM11.3313 5.27943L8.72083 2.66901L9.43542 1.95443C9.67847 1.71137 9.96771 1.58984 10.3031 1.58984C10.6385 1.58984 10.9278 1.71137 11.1708 1.95443L12.0458 2.82943C12.2792 3.06276 12.3958 3.352 12.3958 3.69714C12.3958 4.04227 12.2792 4.33151 12.0458 4.56484L11.3313 5.27943ZM10.4708 6.13984L4.36042 12.2503H1.75V9.63984L7.86042 3.52943L10.4708 6.13984Z",
    fill: "#1565C0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagEdit);
export default __webpack_public_path__ + "static/media/tag-edit.a2818eeade12c842a8313d9535e0e953.svg";
export { ForwardRef as ReactComponent };